/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';
import { MenuItem, Select } from '@mui/material';
import { Option } from '../../../../../../types/Option';
import { t } from 'i18next';
import FILTER_TYPES from '../../../../filterTypes';
import { useCloseOnScroll } from '../../../../../../utils/useCloseOnScroll';

interface SelectFieldProps {
  options: Option[];
  selectedValue: Option;
  unitType?: string;
  placeholder?: string;
  disabled?: boolean;
  handleSelect: (newValue: Option) => any;
}

export const SelectField = (props: SelectFieldProps) => {
  const { options, selectedValue, unitType, placeholder: customPlaceholder, disabled, handleSelect } = props;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  useCloseOnScroll(open, setOpen, anchorRef);
  const defaultPlaceholder = unitType === FILTER_TYPES.workTypeTechnicalAspects
    ? t('filters.filtersPlaceHolder.everyMagnitude')
    : t('filters.filtersPlaceHolder.selectUnit');
  const placeholder = customPlaceholder || defaultPlaceholder;
  return (
    <Select
      ref={anchorRef}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      style={{
        margin: '10px 12px 0px 12px',
        textAlign: 'left',
      }}
      value={selectedValue || ''}
      disabled={disabled || options.length === 0}
      displayEmpty
      renderValue={(value: any) => value === '' ? t(placeholder) : value.name}
      sx={{
        backgroundColor: '#FFFFFF',
        height: '45px',
        '&.MuiOutlinedInput-root': {
          marginBottom: '11px',
          '&.Mui-focused fieldset': {
            border: '1px solid #7A7A7A',
            color: 'rgba(122, 122, 122, 1)'
          },
        },
      }}
    >
      {
        options.map((op) => {
          const opt = {
            code: op.code,
            name: op.name
          };
          return (
            <MenuItem key={op.code} value={op.code}>
              <div
                id='worktypeselector-item'
                className={'menu-item'}
                style= {{ color: '#696969'}}
                onClick={() => {
                  handleSelect(opt);
                }}
              >
                {op.name}
              </div>
            </MenuItem>
          );
        })
      }
    </Select >
  );
};

export default SelectField;
